import { lazy } from 'react';
import authRoles from '../../../auth/authRoles';

const Rates = lazy(() => import('./Rates'));
const AirFreight = lazy(() => import('./tabs/airFreight/airFreight/AirFreight'));
const SeaFreightFCL = lazy(() => import('./tabs/seaFreightFCL/details/SeaFreightFCL'));
const SeaFreightLCL = lazy(() => import('./tabs/seaFreightLCL/details/SeaFreightLCL'));
const FobCharge = lazy(() => import('./tabs/fobCharges/details/FobCharge'));
const ImportRates = lazy(() => import('./importRates/ImportRatesPage'));
const RateGroups = lazy(() => import('./rateGroups/RateGroupsPage'));
const CheckBuySellPage = lazy(() => import('./checkBuyVsSell/CheckBuySellPage'));
const RatesCalculationPage = lazy(() => import('./ratesCalculation/RatesCalculationPage'));

const RatesAppConfig = {
   settings: {
      layout: {
         config: {},
      },
   },
   auth: authRoles.user,
   routes: [
      {
         path: '/operator/rates',
         element: <Rates />,
      },
      {
         path: '/operator/rates/airFreight/:airFreightId',
         element: <AirFreight />,
         children: [
            {
               path: 'version/:versionId',
               element: <AirFreight />,
            },
         ],
      },
      {
         path: '/operator/rates/seaFreightLCL/:seaFreightLCLId',
         element: <SeaFreightLCL />,
         children: [
            {
               path: 'version/:versionId',
               element: <SeaFreightLCL />,
            },
         ],
      },
      {
         path: '/operator/rates/seaFreightFCL/:seaFreightFCLId',
         element: <SeaFreightFCL />,
         children: [
            {
               path: 'version/:versionId',
               element: <SeaFreightFCL />,
            },
         ],
      },
      {
         path: '/operator/rates/fobcharge/:fobChargeId',
         element: <FobCharge />,
      },
      {
         path: '/operator/rates/importfiles',
         auth: authRoles.admin,
         element: <ImportRates />,
      },
      {
         path: '/operator/rates/quarter',
         auth: authRoles.admin,
         element: <RateGroups />,
      },
      {
         path: '/operator/rates/checkbuyandsell',
         auth: authRoles.admin,
         element: <CheckBuySellPage />,
      },
      {
         path: '/operator/rates/calculator/:mode',
         auth: authRoles.admin,
         element: <RatesCalculationPage />,
      },
      {
         path: '/operator/rates/calculator/:mode',
         auth: authRoles.admin,
         element: <RatesCalculationPage />,
      },
      {
         path: '/operator/rates/calculator/:mode',
         auth: authRoles.admin,
         element: <RatesCalculationPage />,
      },
      {
         path: '/operator/rates/calculator/:mode',
         auth: authRoles.admin,
         element: <RatesCalculationPage />,
      },
   ],
};

export default RatesAppConfig;
